import { render, staticRenderFns } from "./ServerTRSmall.vue?vue&type=template&id=1b2adc32&scoped=true&"
import script from "./ServerTRSmall.vue?vue&type=script&lang=js&"
export * from "./ServerTRSmall.vue?vue&type=script&lang=js&"
import style0 from "./ServerTRSmall.vue?vue&type=style&index=0&id=1b2adc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2adc32",
  null
  
)

export default component.exports